import React from 'react';

function Quote() {
  return (
    <div className="Quote">
      <p>
        Lorem ipsum dolor sit amet consectetur a
        dipisicing elit. Vitae laborum a, minima
        Lorem ipsum dolor sit amet consectetur a
        dipisicing elit. Vitae laborum a, minima
      </p>
    </div>
  );
}

export default Quote;
